import { render } from "./TabBar.vue?vue&type=template&id=4b71b3e8&scoped=true"
import script from "./TabBar.vue?vue&type=script&lang=js"
export * from "./TabBar.vue?vue&type=script&lang=js"

import "./TabBar.vue?vue&type=style&index=0&id=4b71b3e8&scoped=true&lang=css"

import exportComponent from "D:\\project\\websites\\lxc_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b71b3e8"]])

export default __exports__